/**
 */
export class MobileComment_ImageNotAvailable_RECORD {
    static copyOfResponse() {
        return JSON.parse(JSON.stringify(this.RESPONSE));
    }
}
MobileComment_ImageNotAvailable_RECORD.PATH = 'tenants/hexagonsdaop/sessions/904d23a3343b4805a4f2dd3f934e6fda_48191398_16492_311163987/dialogs/39/record';
MobileComment_ImageNotAvailable_RECORD.RESPONSE = { "dialogAlias": "MobileComment_ImageNotAvailable", "annotations": [], "id": null, "type": "hxgn.api.dialog.Record", "dialogName": "MobileComment_ImageNotAvailable", "properties": [] };
